import React from 'react';
import { ExclamationIcon, IconButton, RemoveCircleIcon, TextField } from '@onsolve/onsolve-ui-components';
import styles from './EmailField.module.scss';
import { t } from '@lingui/macro';
const EmailField = ({ index, removeEmail, data, handleChange, errors = [] }) => {
    return (<div className={styles.field_item} data-testid="EmailField">
            <TextField type={'text'} name={`emailAddress.${index}`} label={t `Email`} className={styles.field_input} maxLength={120} hideMaxLength placeholder={t `Enter email address`} value={data} onChange={(event) => handleChange(index, event)}/>
            {errors?.find((error) => error.key === index) && (<ExclamationIcon data-qa={`validationError.${index}`} className={styles.field_exclamation_icon_position} color={'danger'}/>)}
            <IconButton name={`removeEmailAddress.${index}`} className={styles.field_remove_button} aria-label={t `Remove email address`} onClick={removeEmail}>
                <RemoveCircleIcon color={'primary'}/>
            </IconButton>
        </div>);
};
export default EmailField;
